import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "fas fa-expand"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-compress"
}
const _hoisted_7 = { key: "equipment" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex status-popup"
}
const _hoisted_9 = { class: "card w-100" }
const _hoisted_10 = { class: "card-header d-flex justify-content-between" }
const _hoisted_11 = { class: "d-fill mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_control = _resolveComponent("l-control")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_circle_marker = _resolveComponent("l-circle-marker")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_StatusComponent = _resolveComponent("StatusComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['map-monitor', { expanded: _ctx.isExpanded }]),
    key: "isExpanded"
  }, [
    _createVNode(_component_l_map, {
      ref: "leafletMap",
      "zoom-control": false,
      style: {"height":"100%"},
      zoom: _ctx.zoom,
      center: _ctx.center
    }, {
      default: _withCtx(() => [
        _createVNode(_component_l_tile_layer, {
          url: _ctx.url,
          attribution: _ctx.attribution
        }, null, 8, ["url", "attribution"]),
        _createVNode(_component_l_control, { position: "topleft" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "custom-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
              }, _hoisted_2)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "custom-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
              }, _hoisted_4)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "custom-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
              }, [
                (!_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                  : (_openBlock(), _createElementBlock("i", _hoisted_6))
              ])
            ])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipments, (marker) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (marker.additional.latitude && marker.additional.longitude)
              ? (_openBlock(), _createBlock(_component_l_circle_marker, {
                  key: 0,
                  "lat-lng": [
            marker.additional.latitude,
            marker.additional.longitude,
          ],
                  color: marker.id == _ctx.equipment.id ? _ctx.colorLib['selected'].border : _ctx.colorLib[marker.status ?? 'default'].border,
                  "fill-color": marker.id == _ctx.equipment.id ? _ctx.colorLib['selected'].background : _ctx.colorLib[marker.status ?? 'default'].background,
                  radius: 15,
                  "fill-opacity": 1,
                  onClick: ($event: any) => (_ctx.openStatus(marker.id)),
                  style: _normalizeStyle({
            cursor: !_ctx.isIndex ? 'default' : 'pointer',
          })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_l_tooltip, {
                      permanent: false,
                      direction: "top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(marker.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["lat-lng", "color", "fill-color", "onClick", "style"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["zoom", "center"]),
    (_ctx.isShowControl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "fas fa-times mr-4",
                  style: {"cursor":"pointer"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeStatus && _ctx.closeStatus(...args)))
                }),
                _createElementVNode("span", {
                  style: {"cursor":"pointer"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toView(_ctx.equipment.id)))
                }, _toDisplayString(_ctx.equipment.name ?? ""), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_StatusComponent, { equipment: _ctx.equipment }, null, 8, ["equipment"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}